import React from "react";
import { HelpCircle } from "lucide-react";
import type { ConversationLostReasonRow } from "../../types";

interface ConversationLostReasonsTableProps {
  lostReasons: ConversationLostReasonRow[];
}

const REASON_LABELS: Record<string, string> = {
  not_interested: "No le interesa",
  price: "Precio",
  bought_elsewhere: "Ya compró en otro lado",
  no_match: "No hay lo que busca",
  just_browsing: "Solo consultaba",
  other: "Otro",
};

export const ConversationLostReasonsTable: React.FC<ConversationLostReasonsTableProps> = ({
  lostReasons,
}) => {
  const totalLost = lostReasons.reduce((acc, curr) => acc + curr.count_lost, 0);

  return (
    <div
      style={{
        background: "var(--bg-surface, #111827)",
        border: "1px solid var(--border-subtle, rgba(255,255,255,0.08))",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "24px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <div>
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "var(--text-primary, #f9fafb)" }}>
            Por qué se fueron
          </h3>
          <p style={{ margin: "4px 0 0", fontSize: "12px", color: "var(--text-muted, #9ca3af)" }}>
            Motivos tipificados de conversaciones que culminaron en abandono (§5.7)
          </p>
        </div>
      </div>

      {lostReasons.length === 0 ? (
        <div style={{ padding: "24px", textAlign: "center", color: "var(--text-muted, #9ca3af)" }}>
          <HelpCircle size={32} style={{ margin: "0 auto 8px", opacity: 0.5 }} />
          <p style={{ margin: 0, fontSize: "14px" }}>Sin abandonos registrados en el rango.</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {lostReasons.map((item) => {
            const label = REASON_LABELS[item.lost_reason] || item.lost_reason || "Sin motivo";
            const pct = totalLost > 0 ? (item.count_lost / totalLost) * 100 : 0;
            return (
              <div
                key={item.lost_reason}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.03)",
                  borderRadius: "6px",
                  border: "1px solid rgba(255,255,255,0.05)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
                  <span style={{ fontSize: "14px", fontWeight: 500, color: "var(--text-primary, #f9fafb)", minWidth: "180px" }}>
                    {label}
                  </span>
                  <div
                    style={{
                      flex: 1,
                      height: "8px",
                      borderRadius: "4px",
                      background: "rgba(255,255,255,0.06)",
                      overflow: "hidden",
                      maxWidth: "240px",
                    }}
                  >
                    <div
                      style={{
                        width: `${pct}%`,
                        height: "100%",
                        background: "#a02626",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px" }}>
                  <strong style={{ color: "var(--text-primary, #f9fafb)" }}>{item.count_lost}</strong>
                  <span style={{ color: "var(--text-muted, #9ca3af)", fontSize: "12px" }}>
                    ({pct.toFixed(0)}%)
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
